// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xOMYxGIOmI_DKz {
  padding: var(--ds-space-150, 10px) var(--ds-space-300, 25px);
  vertical-align: middle;
}
.z74TQRx29PeMLx,
.yae61on0ztVwj7 {
  display: inline;
  margin-right: var(--ds-space-075, 5px);
  margin-left: var(--ds-space-150, 10px);
  font-size: bold;
  vertical-align: text-bottom;
}
.yae61on0ztVwj7 {
  border-bottom: 1px dashed var(--ds-text-subtlest, #626f86);
  cursor: pointer;
}
.LK1F7deL77Ep4i td:nth-child(4) {
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
`, ""]);
// Exports
export var featureContent = `xOMYxGIOmI_DKz`;
export var featureNameNoTooltip = `z74TQRx29PeMLx`;
export var featureName = `yae61on0ztVwj7`;
export var row = `LK1F7deL77Ep4i`;
export default ___CSS_LOADER_EXPORT___;
